import { render, staticRenderFns } from "./ChatParticipants.vue?vue&type=template&id=6716621c&scoped=true&"
import script from "./ChatParticipants.vue?vue&type=script&lang=ts&"
export * from "./ChatParticipants.vue?vue&type=script&lang=ts&"
import style0 from "./ChatParticipants.vue?vue&type=style&index=0&id=6716621c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716621c",
  null
  
)

export default component.exports